export default __webpack_public_path__ + "static/media/harvard.ff568b55.png";